import AttendeeCustomTable from '../../components/AttendeeCustomTable/CustomTable';
import styles from './viewShowAttendee.module.scss';
import React, { useEffect } from 'react';

const ViewShowAttendees = React.memo(() => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={styles.indexdiv}>
      <AttendeeCustomTable />
    </div>
  );
});
export default ViewShowAttendees;
